// An highlighted block
<template>
  <div>
    <el-input size="mini" v-popover:popover v-model="carNo" :readonly="readonly" :disabled="disabled" >
      <span v-if="!disabled" slot="append" @click="visible = !visible">
              <el-button slot="append" icon="el-icon-truck"></el-button>
          </span>
    </el-input>
    <el-popover
        ref="popover"
        width="332"
        popper-class="car_no_popover"
        v-model="visible"
        :trigger="(readonly || disabled) ? '' : 'click'">
      <div class="row_div">
        <div class="every_div" v-for="(item) in area" :key="item">
          <button :disabled="carNo.length > 0" @click="selectCarNo(item)">{{ item }}</button>
        </div>
      </div>
      <div class="row_div">
        <div class="every_div" v-for="item in areaLetter" :key="item">
          <button @click="selectCarNo(item)">{{ item }}</button>
        </div>
      </div>
      <div class="row_div">
        <div class="every_div" v-for="item in areaDigit" :key="item">
          <button :disabled="area.indexOf(carNo) != -1" @click="selectCarNo(item)">{{ item }}</button>
        </div>
        <div class="btn_div">
          <el-button type="primary" size="mini" icon="el-icon-back" @click="backBtnHandle"></el-button>
          <el-button type="primary" size="mini" @click="clearBtnHandle">清除</el-button>
          <el-button type="primary" size="mini" @click="visible = false">确认</el-button>
        </div>
      </div>
    </el-popover>
  </div>
</template>
<script>

//{required: true, message: this.$t('车号是必填项')},
//{validator: this.validateCarNum, message: '车牌号格式不正确'}
export default {
  description: '车号选择器',
  name: 'l-car-number',
  props: {
    value: {},
    disabled: Boolean,
    keymap: Boolean,
    readonly: Boolean,
    placement:{
      type: String,
      default: 'bottom'
    },
    minlength:{
      type: Number,
      default:0
    },
    maxlength: {
      type: Number,
      default:0
    }
  },
  data() {
    return {
      visible: false,
      carNo: '',
      area: [
      "鲁", "冀", "豫", "黑","辽", "苏", "浙","晋", "蒙", "陕", "吉", "京", "津", "沪", "渝", "云", "湘", "皖", "新", 
        "赣", "鄂", "桂", "甘", "贵", "粤", "青", "藏", "川", "宁", "琼"
      ],
      areaLetter: [
        "A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "O",
        "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"
      ],
      areaDigit: [
        "1", "2", "3", "4", "5", "6", "7", "8", "9", "0"
      ],
    }
  },
  watch: {
    carNo:{
            handler(newVal){
              if(newVal != this.value){
                this.$emit('input', newVal)
              }
            },
            immediate: true
        }
    },
  methods: {
    validate(callback){
      let flag = false
      let reg8 =
          /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
      let reg7 =
          /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
      if (this.carNo.length === 7) {
        flag = reg7.test(this.carNo);
      } else if (this.carNo.length === 8) {
        flag = reg8.test(this.carNo);
      }
      if (flag) {
        callback();
      } else {
        return callback(new Error("车牌号格式不正确"));
      }
    },
    selectCarNo(item) {
      if(this.carNo && this.maxlength > 0 && this.carNo.length >= this.maxlength){
        return;
      }
      this.carNo = this.carNo + item
      //this.$emit('update:modelValue', this.carNo)
      //this.$emit('input', this.carNo)
    },
    backBtnHandle(){
      if(this.carNo.length > 0){
        this.carNo = this.carNo.substring(0, this.carNo.length - 1)
        //this.$emit('update:modelValue', this.carNo)
        //this.$emit('input', this.carNo)
      }
    },
    clearBtnHandle(){
      this.carNo = ''
      //this.$emit('update:modelValue', this.carNo)
      //this.$emit('input', this.carNo)
    }
  }
}
</script>
<style lang="less">
@import './index.less';
</style>

